import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['profileDropdown'];

    connect() {
        this.highlightActiveLink();
        this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    }

    disconnect() {
        document.removeEventListener('click', this.boundHandleOutsideClick);
    }

    highlightActiveLink() {
        const links = document.querySelectorAll('#icon'); 
        const currentPath = window.location.pathname; 

        links.forEach(link => {
            if (link.getAttribute('href') === currentPath) {
                link.classList.add('bg-[#954D9B]');
            }

            link.addEventListener('click', () => {
                links.forEach(l => l.classList.remove('bg-[#954D9B]'));
                link.classList.add('bg-[#954D9B]');
            });
        });
    }

    toggleProfileDropdown(event) {
        if (event) {
            event.stopPropagation();
        }
        
        if (this.hasProfileDropdownTarget) {  
            const wasHidden = this.profileDropdownTarget.classList.contains('hidden');
            this.profileDropdownTarget.classList.toggle('hidden');

            if (wasHidden) {
                setTimeout(() => {
                    document.addEventListener('click', this.boundHandleOutsideClick);
                }, 0);
            } else {
                document.removeEventListener('click', this.boundHandleOutsideClick);
            }
        }
    }

    handleOutsideClick(event) {
        if (this.hasProfileDropdownTarget && !this.profileDropdownTarget.classList.contains('hidden')) {
            const dropdown = this.profileDropdownTarget;
            const toggleButton = this.element.querySelector('[data-action*="toggleProfileDropdown"]');
            
            
            const clickedInsideDropdown = dropdown.contains(event.target);
            const clickedOnToggle = toggleButton && toggleButton.contains(event.target);
            
            
            if (!clickedInsideDropdown && !clickedOnToggle) {
                this.profileDropdownTarget.classList.add('hidden');
                document.removeEventListener('click', this.boundHandleOutsideClick);
            }
        }
    }

}